<template>
  <div class="content">
    <!-- <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">数据报表</h3> -->
    <!-- <div class="header"></div> -->
    <div class="flex-div">
      <div class="f-item">
        <div class="f-item-top">
          <p class="p-title"><i class="el-icon-s-help"></i>{{$store.state.themeTitle}}室总览</p>
          <div class="ul-div">
            <el-carousel :interval="10000" style="height:100%;" v-if="srcList.length>0">
              <el-carousel-item v-for="item in Math.ceil(srcList.length/4)" :key="item">
                <div style="height:100%;display: flex;flex-wrap: wrap;justify-content: space-between;">
                  <div class="d-imge" v-for="(src,i) in srcList.slice((item-1)*4,(item-1)*4+4)" :key="i">
                    <el-image ref="previewImg" style="width:100%;height: 100%;border-radius: 2px;" :src="src" :preview-src-list="srcList" fit="cover"></el-image>
                    <div @click="viewPicture((item-1)*4+i)" style="position: absolute;text-align: center;bottom: 0;background: #ccc;background: #00000078; width: 100%;">
                      <i class="el-icon-zoom-in" style="color: #c5c5c5;font-size: 17px;font-weight: bold;"></i>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <el-empty style="height:100%;" v-else description="暂无预览图"></el-empty>
          </div>
        </div>
        <div class="f-item-bottom">
          <p class="p-title"><i class="el-icon-s-help"></i>{{$store.state.themeTitle}}室利用率 <span @click="handlePath('/trainingRoom')" style="float:right;cursor: pointer;">前往列表</span></p>
          <div class="ul-div" id="pieOfUse">
            <v-chart theme="macarons" :options="pieUseOption" style="margin:0 atuo;" />
          </div>
        </div>
      </div>
      <div class="f-item">
        <p class="p-title"><i class="el-icon-s-data"></i>{{$store.state.themeTitle}}室设备使用情况 <span @click="handlePath('/EquipmentCounts')" style="float:right;cursor: pointer;">前往列表</span></p>
        <div class="ul-div" id="barEqOption">
          <v-chart theme="macarons" :options="barEqOption" style="margin:0 atuo;" />
        </div>
      </div>
      <div class="f-item">
        <p class="p-title"><i class="el-icon-s-data"></i>{{$store.state.themeTitle}}室设备及资产情况<span @click="handlePath('/trainingRoom')" style="float:right;cursor: pointer;">前往列表</span></p>
        <div class="ul-div" id="barEqOption">
          <v-chart theme="macarons" :options="barEqZJOption" style="margin:0 atuo;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts';
// import * as echarts from 'echarts';

export default {
  name: 'demoEchart',
  data() {
    return {
      lineOption: {
        xAxis: {
          type: 'category',
          data: [],
        },
        toolbox: {
          show: true,
          title: '详情',
          feature: {
            dataView: {
              readOnly: false,
              optionToContent: function (opt) {
                var axisData = opt.xAxis[0].data;
                var series = opt.series;
                var tableHead = "<table style='width:100%'><tr><th>名称</th><th>次数</th></tr>";
                var tableFoot = '</table>';
                var tableHtml = '';
                axisData.map((item, index) => {
                  tableHtml += `<tr><td>${item}</td><td>${series[0].data[index]}</td></tr>`;
                });
                return tableHead + tableHtml + tableFoot;
              },
            },
          },
        },
        yAxis: {
          name: '次数',
          type: 'value',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#4578ed',
            },
            itemStyle: {
              color: '#4578ed',
            },
          },
        ],
      },
      lineTOption: {},
      barEqOption: {
        backgroundColor: '#29283C',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true,
              backgroundColor: '#333',
            },
          },
        },
        legend: {
          data: ['line', 'bar'],
          textStyle: {
            color: '#ccc',
          },
        },
        xAxis: {
          data: [],
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.21)',
            },
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(255,255,255,0.21)',
            },
          },
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.21)',
            },
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(255,255,255,0.21)',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.21)',
            },
          },
        },
        series: [
          {
            name: '使用情况',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 2,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#14D2D7', // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#27A5EA', // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            data: [],
          }
        ],
      },
      barEqSHOption: {},
      barEqZJOption: {},
      pieUseOption: {
        backgroundColor: '#29283C',
        legend: {
          top: 20,
          left: 'center',
        },
        toolbox: {
          show: true,
          title: '详情',
          feature: {
            dataView: {
              readOnly: false,
            },
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      },
      srcList: [],
    };
  },
  components: {
    'v-chart': ECharts,
  },
  created() {
    //  this.barEqZJOption.
    this.getBanners();
  },
  mounted() {
    this.$nextTick(() => {});
    // this.lineTOption = this.$until.deepCopy(this.lineOption);
    // this.barEqSHOption = this.$until.deepCopy(this.barEqOption);
    this.barEqZJOption = this.$until.deepCopy(this.barEqOption);
    // this.barEqZJOption.yAxis[0].name = '总价';
    // this.barEqZJOption.series[0].name = '总价';
    // this.barEqZJOption.tooltip = {
    //   formatter: function (params, ticket, callback) {
    //     let data = params.data;
    //     return `${params.name}<br />数量：${data.num}<br />价格：${data.price}<br />总价：${data.value}`;
    //   },
    // };
    // this.getStudentApply()
    // this.getProvince()
    this.room_use();
    // this.teacher_class();
    // this.student_sign();
    this.room_device();
    // this.device_wear();
    this.device_capital();
  },
  methods: {
    viewPicture(index) {
      // console.log(this.$refs.previewImg)
      console.log(index);
      this.$refs.previewImg[index].showViewer = true;
    },
    async getBanners() {
      let params = {};
      let res = await this.$api.instance.interfaceServer(`api/banner`, 'get', params);
      if (res.code == 0) {
        this.srcList = res.data.map((item) => {
          return item.file;
        });
      }
    },
    async room_use() {
      let res = await this.$api.query.room_use();
      if (res.code == 0 && res.data && res.data.avg_rate) {
        let data = [
          { value: res.data.avg_rate, name: '已利用' },
          { value: 1 - res.data.avg_rate, name: '未利用' },
          // { value: res.data.use.free, name: '空闲' },
        ];
        this.pieUseOption.series[0].data = data;
      }
    },
    handlePath(path) {
      this.$router.push(path);
    },
    async teacher_class() {
      let res = await this.$api.query.teacher_class();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.count;
          }),
          name = res.data.map((item) => {
            return item.date;
          });
        this.lineTOption.series[0].data = value;
        this.lineTOption.xAxis.data = name;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
    async student_sign() {
      let res = await this.$api.query.student_sign();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.count;
          }),
          name = res.data.map((item) => {
            return item.date;
          });
        this.lineOption.series[0].data = value;
        this.lineOption.xAxis.data = name;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
    async room_device() {
      let res = await this.$api.query.room_device();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.device_num;
          }),
          name = res.data.map((item) => {
            return item.device_name;
          });
        this.barEqOption.series[0].data = [212, 323, 231, 124, 432, 23, 78, 145, 253, 76];
        this.barEqOption.xAxis.data = ['A201', 'A202', 'A203', 'A204', 'A205', 'A206', 'A207', 'A208', 'A3201', 'A3202'];
        // let space = (5 / value.length) * 100;
        // this.barEqOption.dataZoom[0].end = space > 100 ? 100 : space;
        // this.barEqOption.dataZoom[1].end = space > 100 ? 100 : space;
      }
    },
    async device_wear() {
      let res = await this.$api.query.device_wear();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return item.device_num;
          }),
          name = res.data.map((item) => {
            return item.device_name;
          });
        this.barEqSHOption.series[0].data = value;
        this.barEqSHOption.xAxis[0].data = name;
        let space = (5 / value.length) * 100;
        this.barEqSHOption.dataZoom[0].end = space > 100 ? 100 : space;
        this.barEqSHOption.dataZoom[1].end = space > 100 ? 100 : space;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
    async device_capital() {
      let res = await this.$api.query.device_capital();
      if (res.code == 0) {
        let value = res.data.map((item) => {
            return { value: item.device_num * item.device_price, num: item.device_num, price: item.device_price };
          }),
          name = res.data.map((item) => {
            return item.device_name;
          });
        this.barEqZJOption.series[0].data = value;
        this.barEqZJOption.xAxis[0].data = name;
        let space = (5 / value.length) * 100;
        this.barEqZJOption.dataZoom[0].end = space > 100 ? 100 : space;
        this.barEqZJOption.dataZoom[1].end = space > 100 ? 100 : space;
        // this.$message({
        //   type: 'success',
        //   center: true,
        //   message: '打分成功成功！',
        // });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.d-imge {
  width: calc(50% - 10px);
  height: calc(50% - 20px);
  position: relative;
}
.content {
  overflow: auto;
  box-sizing: border-box;
  height: inherit;
  background: #1e1e2c;
  padding: 0px 16px 16px 16px;
  padding: 24px;
  .header {
    height: 60px;
  }
}
.echarts {
  margin: 0 auto;
  width: inherit;
  height: inherit;
}
.flex-div {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
  .f-item {
    margin: 4px;
    width: calc(33.3% - 4px);
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    > div {
      padding: 12px;
      box-sizing: border-box;
      background: #29283c;
      border-radius: 3px;
      height: calc(50% - 8px);
      cursor: pointer;
    }
    &-top {
    }
    &-bottom {
    }
    .div-style {
      display: flex;
      padding: 16px;
      border-radius: 4px;
      // background: #ffffff;
      margin-top: 16px;
      height: calc(100% - 72px);
      overflow: auto;
      div {
        width: 451px;
        height: 308px;
        overflow: hidden;

        // background:#ccc;
      }
    }
    .ul-div {
      padding: 16px;
      margin-top: 16px;
      width: 100%;
      // height: calc(100% - 72px);
      height: calc(100% - 45px);
      box-sizing: border-box;
      overflow: hidden;
      .ul-style {
        list-style: none;
        li {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 12px;
          .p-l {
            width: 320px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }
          .p-l:hover {
            color: #6d4827;
            text-decoration: underline;
          }
          .p-r {
            color: #8c8c8c;
            text-align: right;
          }
        }
      }
    }

    .p-title {
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 2px;
      // font-weight: bold;
      // color: #fff;
      color: #0cd2d7;
      i {
        font-size: 32px;
        vertical-align: middle;
        margin-right: 8px;
      }
      span {
        font-size: 14px;
        color: #54545d;
      }
      // font-style: italic;
      // font-weight: bold;
    }
  }
  // .f-item:nth-child(2n) {
  //   margin-right: 0px;
  // }
}
.pageHeader:before {
  width: var(--width);
}
.pageHeader {
  margin-bottom: 12px;
}
.tt {
  width: 100%;
}
</style>
